import { http } from 'services';

// instance - View details
export function getDetails(cbSuccess, cbError) {
  http.get(
    'instance/profile',
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// instance - Update details
export function updateDetails(payload, cbSuccess, cbError) {
  http.patch(
    'instance/profile',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// instance - View details
export function getSettingsReginalAndLanguage(cbSuccess, cbError) {
  http.get(
    'instance/settings/regional-and-language',
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-instance/api-instance-profile.js